import useStoreSelector from 'store/useStoreSelector';

function useIsLogged() {
	const { logged } = useStoreSelector(({ session }) => session);

	return logged;
}

export default useIsLogged;
